import React from 'react'
import Admin from './pages/admin/Admin';

function App() {
  return (
    <Admin/>
  )
}

export default App;
